import React from 'react';
import classnames from 'classnames';
import { RacingMarketTypes } from '@common/constants/enums/racingMarketTypes';
import { useTranslation } from '@common/hooks/translation';
import { useSelections } from '@racings/hooks/selections';

export const RacingEvent = ({
  event, game, market, index, racingData,
}) => {
  const t = useTranslation();
  const [selections, toggleEvent] = useSelections();

  const jockeyImage = racingData?.jockeyInfo?.coloursFilename;
  const jokeyName = racingData?.jockeyInfo?.name;
  const trainerName = racingData?.trainerInfo.name;

  const onToggleEvent = (e) => {
    e.stopPropagation();
    toggleEvent({
      event: {
        ...event,
        sp: !event.price,
        ew_allowed: market.event?.[event.id]?.ew_allowed,
        price: !event.price ? -1 : event.price,
      },
      regionId: game.regionId,
      competitionId: game.competitionId,
      game,
      market,
      activeMarketId: RacingMarketTypes.WINNER,
    });
  };

  const selectedEvent = selections[event.id] && selections[event.id].event.price === (event.price || -1);

  return (
    <div key={event.id} className="event" onClick={onToggleEvent}>
      <div className="jockey-wrpapper">
        <span>{index + 1}</span>
        {jockeyImage && <img src={jockeyImage} alt="" />}
      </div>
      <div className="jockey-triner-info">
        <span>{event.name}</span>
        {trainerName && <span>T: {trainerName}</span>}
        {jokeyName && <span>J: {jokeyName}</span>}
      </div>
      <div className={classnames('event-price', { active: !!selectedEvent })}>
        {event.price || t('SP')}
      </div>
    </div>
  );
};
